import React, { useState, useEffect } from "react";

const Aboutus = () => {
  const [qst, setQst] = useState([
    {
      qst: "¿Es seguro vender mi arte en el marketplace?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
    {
      qst: "¿Se puede pagar o cobrar con criptomonedas? ¿Y con FIAT?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
    {
      qst: "¿Existe algún tipo de coste adicional para un artista?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
  ]);

  const Questions = ({ data }) => {
    const [open, setOpen] = useState(false);
    return (
      <div className="item flex flex-col">
        <div className="qst flex aic justify-between">
          <div className="qst-lbl">{data.qst}</div>
          <div className="ico cursor-pointer" onClick={(e) => setOpen(!open)}>
            {open ? (
              <img src="./images/minusIcon.svg" className="img" />
            ) : (
              <img src="./images/PlusIcon.svg" className="img" />
            )}
          </div>
        </div>
        <div className={`ans ${open ? "open" : ""}`}>
          SI. Gracias al blockchain y a los smart contracts auditados ofrecemos
          una seguridad inquebrantable.
        </div>
      </div>
    );
  };
  return (
    <div className="about-us-page flex flex-col">
      <div className="hero-sec flex aic jc">
        <div className="hero-sec-desc">Quienes SOMOS</div>
      </div>
      <div className="vender-sec-b flex flex-col">
        <div className="vender-b-wrap wrapWidth flex-col">
          <div className="sec-b-desc">
            Somos un marketplace especializado en el sector del arte, dónde
            puedes comprar y vender NFTs de una forma segura, transparente,
            eficaz, legal, profesional y efectiva.
          </div>
          <div className="what-do flex flex-col">
            <div className="what-do-tag">¿Qué hacemos?</div>
            <div className="what-do-block">
              <div className="what-do-card flex flex-col ">
                <img src="./images/nft-21.svg" className="img" />
                <div className="card-dec">
                  Convertimos obras de arte en NFTs, las alojamos y
                  posicionamos.
                </div>
              </div>
              <div className="what-do-card flex flex-col ">
                <img src="./images/ventas1.svg" className="img" />
                <div className="card-dec">
                  Impulsamos las ventas de galerías y artistas a nivel mundial.
                </div>
              </div>
              <div className="what-do-card flex flex-col ">
                <img src="./images/tierra1.svg" className="img" />
                <div className="card-dec">
                  Ofrecemos un servicio integral de creación y venta de NFTs y
                  colecciones.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="apply flex aic jc flex-col">
        <div className="apply-tag">
          Somos el marketplace NFT Art más completo y especializado del mercado.
        </div>
      </div>
      <div className="depart-sec flex flex-col aic">
        <div className="wrap wrapWidth flex flex-col">
          <div className="depart-tag">Departamentos</div>
          <div className="depart-desc">
            6 departamentos totalmente alineados y especializados para darte un
            servicio integral en la venta, compra e inversión en Arte.
          </div>
        </div>
        <div className="depart-sec">
          <div className="action flex aic jc">
            <div className="btn button">Compradores</div>
          </div>
          <div className="action flex aic jc">
            <div className="btn button">Vendedores</div>
          </div>
          <div className="action flex aic jc">
            <div className="btn button">Inversores</div>
          </div>
          <div className="action flex aic jc">
            <div className="btn button">Formación</div>
          </div>
          <div className="action flex aic jc">
            <div className="btn button">Marketplace</div>
          </div>
          <div className="action flex aic jc">
            <div className="btn button">Marketing NFT/Cripto</div>
          </div>
        </div>
      </div>
      <div className="wrok-type flex flex-col">
        <div className="wrap wrapWidth flex">
          <div className="left flex">
            <div className="bgImage flex aic jc">
              <div className="tag">Nuestras bases</div>
            </div>
          </div>
          <div className="right flex flex-col aic jc">
            <div className="right-blk flex-col flex">
              <div className="item flex aic">
                <div className="icon flex">
                  <img src="./images/chequeIcon.svg" className="img" />
                </div>
                <div className="desc">
                  <span>Servicio 360:</span> Creación, transformación,
                  posicionamiento y venta de NFTs.
                </div>
              </div>
              <div className="item flex aic">
                <div className="icon flex">
                  <img src="./images/chequeIcon.svg" className="img" />
                </div>
                <div className="desc">
                  <span>UX:</span> Plataforma usable, moderna y atractiva.
                </div>
              </div>
              <div className="item flex aic">
                <div className="icon flex">
                  <img src="./images/chequeIcon.svg" className="img" />
                </div>
                <div className="desc">
                  <span>Seguridad 100%:</span> Filtrado de artistas y obras de
                  arte.
                </div>
              </div>
              <div className="item flex aic">
                <div className="icon flex">
                  <img src="./images/chequeIcon.svg" className="img" />
                </div>
                <div className="desc">
                  <span>Apoyo 360:</span> Respaldo profesional y cualificado.
                </div>
              </div>
              <div className="item flex aic">
                <div className="icon flex">
                  <img src="./images/chequeIcon.svg" className="img" />
                </div>
                <div className="desc">
                  <span>Comunidad:</span> Pertenecer a una comunidad
                  (networking, eventos, descuentos, formación, etc.).
                </div>
              </div>
              <div className="item flex aic">
                <div className="icon flex">
                  <img src="./images/chequeIcon.svg" className="img" />
                </div>
                <div className="desc">
                  <span> RSC:</span> Aportar valor a la sociedad.
                </div>
              </div>
            </div>
            <div className="action flex aic jc">
              <div className="btn button">Descubre nuestro marketplace</div>
            </div>
          </div>
        </div>
      </div>
      <div className="our-support flex flex-col">
        <div className="wrap wrapWidth flex flex-col">
          <div className="support-tag">Nuestro respaldo</div>
          <div className="desc">
            Es un marketplace ideado, creado y diseñado por NFTs Total e
            impulsado por Inviertercript Group.{" "}
          </div>
        </div>
      </div>
      <div className="map-sec flex aic jc">
        <div className="about-map">
          El mundo no es nuestro límite.
          <br />
          <br /> Ofrecemos un servicio integral en todos los continentes
          7/24/365
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
